import React from 'react';
import { executiveProfile } from '../data/corporateData';
import { CheckCircle2 } from 'lucide-react';

const ExecutiveProfile = () => {
  return (
    <section className="py-16 sm:py-24 bg-[#0F172A]" id="profile">
      <div className="container mx-auto px-4 sm:px-8 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image Side */}
          <div className="relative" data-testid="executive-profile-image">
            <div className="relative overflow-hidden rounded-lg">
              <img
                src={executiveProfile.image}
                alt={executiveProfile.name}
                className="w-full h-auto object-cover rounded-lg"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A192F]/60 to-transparent"></div>
            </div>
            {/* Accent Border */}
            <div className="absolute -bottom-4 -right-4 w-32 h-32 border-4 border-rose-500/30 rounded-lg -z-10"></div>
          </div>

          {/* Content Side */}
          <div>
            <div className="mb-4">
              <span className="text-xs font-bold tracking-[0.2em] uppercase text-rose-500 font-heading">
                Executive Profile
              </span>
            </div>
            
            <h2 
              className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white mb-3 font-heading"
              data-testid="executive-profile-name"
            >
              {executiveProfile.name}
            </h2>
            
            <p className="text-lg sm:text-xl font-medium text-slate-300 mb-6 font-body">
              {executiveProfile.title}
            </p>

            <p 
              className="text-base text-slate-300 leading-relaxed mb-8 font-body"
              data-testid="executive-profile-summary"
            >
              {executiveProfile.summary}
            </p>

            {/* Expertise List */}
            <div className="space-y-3" data-testid="executive-profile-expertise">
              <h3 className="text-lg font-semibold text-white mb-4 font-heading">
                Core Expertise
              </h3>
              {executiveProfile.expertise.map((item) => (
                <div 
                  key={item.id} 
                  className="flex items-start gap-3"
                  data-testid={`expertise-item-${item.id}`}
                >
                  <CheckCircle2 className="text-rose-500 flex-shrink-0 mt-0.5" size={20} />
                  <span className="text-slate-300 font-body">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExecutiveProfile;
